<!--Pagination的重新封装-->
<!--上个版本封装不够好 有bug 改动底层 需要大规模修改-->
<template>
  <div class="uk-flex uk-flex-right" style="padding-top: 10px">
    <!--page-count:页码按钮数量-->
    <el-pagination
      background
      :layout="layout"
      :current-page.sync="currentPage"
      :page-sizes.sync="pageSizes"
      :pager-count="5"
      :total="total"
      :page-size.sync="pageSize"
      @current-change="currentChange"
      @size-change="sizeChange"
    />
  </div>
</template>
<script>
import { _debounce } from '@/utils/common'

export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    // 初始长度
    size: {
      type: Number,
      default: 15
    },
    // 显示的控件
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    }
  },
  watch: {
    size: {
      handler () {
        /**
         * 检查是否再分页数列表里存在
         * 假如不存在 在头部插入页数 （其实这里应该在合适的地方插入页数）
         */
        this.pageSize = this.size
        let index = this.pageSizes.indexOf(this.size)
        if (index === -1) {
          // 找到合适的位置插入
          for (let i = 0; i < this.pageSizes.length; i++) {
            if (this.pageSizes[i] > this.size) {
              index = i
              break
            }
            i++
          }
          this.pageSizes.splice(index, 0, this.size)

          this.$nextTick(() => {
            this.pageSize = this.size
          })
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      // 页码 交给自身维护   传入iDisplay反而容易陷入死循环  需要重置直接调用reset方法
      currentPage: 1,
      pageSize: 10,
      pageSizes: [15, 20, 30, 40, 50, 100]
    }
  },
  methods: {
    // 当前页更改时 转换为后端提供的参数
    currentChange: _debounce(function (current) {
      const start = (current - 1) * this.pageSize
      this.$emit('currentChange', {
        iDisplayStart: start,
        iDisplayLength: this.pageSize
      })
    }),
    sizeChange () {
      this.currentChange(this.currentPage)
    },
    /**
     * reset页数 供外部调用
     */
    reset () {
      this.currentPage = 1
    },
    /**
     * 根据iDisplayStart设置当前是第几页
     * 给外部调用
     */
    setPage (iDisplayStart) {
      return parseInt(iDisplayStart / this.size) + 1
    }
  },
  mounted () {}
}
</script>

<style scoped lang="scss">
::v-deep .el-pagination.is-background ::v-deep .el-pager li:not(.disabled).active {
  background-color: var(--primary-color) !important;
}

::v-deep .el-icon-arrow-left {
  color: var(--primary-color) !important;
}
</style>
